import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INIT_PROFILE_STEPS } from '../utils';

export interface ProfileSteps {
  profile: 'Profile';
  family: 'Family';
  questionnaire: undefined | 'questionnaire';
  decisionSupport: undefined | 'decisioniq' | 'bundles';
  chatSupport: undefined | 'olive-advisor';
}
export interface EnrollmentStatusState {
  enrollmentLatest: string;
  totalSubNavItems: (string | undefined)[] | undefined;
  currentSubNavItem: number;
  maxSubNavItem: number;
  profileSteps: ProfileSteps;
}

const initialState: EnrollmentStatusState = {
  enrollmentLatest: 'undefined',
  totalSubNavItems: undefined,
  currentSubNavItem: 0,
  maxSubNavItem: 0,
  profileSteps: INIT_PROFILE_STEPS,
};

const enrollmentStatusSlice = createSlice({
  name: 'enrollmentStatus',
  initialState,
  reducers: {
    setEnrollmentLatest: (state, { payload }: PayloadAction<string>) => {
      state.enrollmentLatest = payload;
    },
    setTotalSubNavItems: (
      state,
      { payload }: PayloadAction<(string | undefined)[] | undefined>
    ) => {
      state.totalSubNavItems = payload;
    },
    setCurrentSubNavItem: (state, { payload }: PayloadAction<number>) => {
      state.currentSubNavItem = payload;
    },
    setMaxSubNavItem: (state, { payload }: PayloadAction<number>) => {
      state.maxSubNavItem = payload;
    },
    setProfileSteps: (state, { payload }: PayloadAction<ProfileSteps>) => {
      state.profileSteps = payload;
    },
  },
});

const { reducer, actions } = enrollmentStatusSlice;

export const {
  setEnrollmentLatest,
  setTotalSubNavItems,
  setCurrentSubNavItem,
  setMaxSubNavItem,
  setProfileSteps,
} = actions;

export const enrollmentStatusReducer = reducer;
